"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.decodeStringParameter = exports.parseDecodedParams = exports.getAbiByName = void 0;
var address_1 = require("@celo/base/lib/address");
var getAbiByName = function (abi, methodName) {
    return abi.find(function (entry) { return entry.name === methodName; });
};
exports.getAbiByName = getAbiByName;
var parseDecodedParams = function (params) {
    var args = new Array(params.__length__);
    Object.keys(params).forEach(function (key) {
        if (key === '__length__') {
            return;
        }
        var argIndex = parseInt(key, 10);
        if (argIndex >= 0) {
            args[argIndex] = params[key];
            delete params[key];
        }
    });
    return { args: args, params: params };
};
exports.parseDecodedParams = parseDecodedParams;
var decodeStringParameter = function (ethAbi, str) {
    return ethAbi.decodeParameter('string', (0, address_1.ensureLeading0x)(str));
};
exports.decodeStringParameter = decodeStringParameter;
//# sourceMappingURL=abi-utils.js.map